export const initState = {
    gen_type: undefined,
    installation: undefined,
    settingInfo: undefined,
    baseDeviceInfo: undefined,
    siteConfiguration: undefined,
    deviceList: undefined,
    acDeviceType: undefined,
    isConsumptionCT: true,
};
const prefix = 'device';
export const DEVICE_ACTION = {
    SET_GEN_TYPE: `${prefix}/setGenType`,
    SET_INSTALLATION_INFO: `${prefix}/setInstallationInfo`,
    SET_SETTING_INFO: `${prefix}/setSettingInfo`,
    SET_BASE_DEVICE_INFO: `${prefix}/setBaseDeviceInfo`,
    SET_SITE_CONFIGURATION_INFO: `${prefix}/setSiteConfigurationInfo`,
    SET_DEVICE_LIST: `${prefix}/setDeviceList`,
    SET_AC_DEVICE_TYPE: `${prefix}/setACDeviceType`,
    SET_IS_CONSUMPTION_CT: `${prefix}/setIsConsumptionCT`,
    CLEAR: `${prefix}/clear`,
};
export default {
    namespaced: true,
    state: { ...initState },
    mutations: {
        setGenType(state, payload) {
            state.gen_type = payload;
        },
        setInstallationInfo(state, payload) {
            state.installation = payload;
        },
        setSettingInfo(state, payload) {
            state.settingInfo = payload;
        },
        setBaseDeviceInfo(state, payload) {
            state.baseDeviceInfo = payload;
        },
        setSiteConfigurationInfo(state, payload) {
            state.siteConfiguration = payload;
        },
        setDeviceList(state, payload) {
            state.deviceList = payload;
        },
        setACDeviceType(state, payload) {
            state.acDeviceType = payload;
        },
        setIsConsumptionCT(state, payload) {
            state.isConsumptionCT = payload;
        },
        clear(state) {
            state.gen_type = undefined;
            state.installation = undefined;
            state.settingInfo = undefined;
            state.baseDeviceInfo = undefined;
            state.siteConfiguration = undefined;
            state.deviceList = undefined;
        },
    },
    actions: {
        setGenType({ commit }, payload) {
            commit('setGenType', payload);
        },
        setInstallationInfo({ commit }, payload) {
            commit('setInstallationInfo', payload);
        },
        setSettingInfo({ commit }, payload) {
            commit('setSettingInfo', payload);
        },
        setBaseDeviceInfo({ commit }, payload) {
            commit('setBaseDeviceInfo', payload);
        },
        setSiteConfigurationInfo({ commit }, payload) {
            commit('setSiteConfigurationInfo', payload);
        },
        setDeviceList({ commit }, payload) {
            commit('setDeviceList', payload);
        },
        setACDeviceType({ commit }, payload) {
            commit('setACDeviceType', payload);
        },
        setIsConsumptionCT({ commit }, payload) {
            commit('setIsConsumptionCT', payload);
        },
        clear({ commit }) {
            commit('clear');
        },
    },
};
